import { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import { Counter } from './Counter'
import Icons from './Icons'

const stats = [
  {
    value: 50000000,
    suffix: '+',
    label: '全球注册用户',
    icon: Icons.Users,
    color: '#ff00ff',
  },
  {
    value: 100,
    suffix: '亿+',
    label: '日交易额（美元）',
    icon: Icons.Chart,
    color: '#00ffff',
  },
  {
    value: 500,
    suffix: '+',
    label: '交易对',
    icon: Icons.Globe,
    color: '#ff00ff',
  },
  {
    value: 0,
    suffix: '',
    label: '重大安全事故',
    icon: Icons.Security,
    color: '#00ffff',
    displayValue: '0',
  },
]

export function Stats() {
  const statsRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        '.stat-card',
        { opacity: 0, y: 30 },
        {
          opacity: 1,
          y: 0,
          duration: 0.6,
          stagger: 0.15,
          scrollTrigger: {
            trigger: statsRef.current,
            start: 'top 80%',
          },
        }
      )
    }, statsRef)

    return () => ctx.revert()
  }, [])

  return (
    <section
      ref={statsRef}
      id="stats"
      className="section-padding relative overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0f] via-[#13131a] to-[#0a0a0f]" />

      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            <span className="gradient-text">安全数据展示</span>
          </h2>
          <p className="text-[#8080a0] text-lg max-w-2xl mx-auto">
            okb官方网站的安全运营数据，见证平台稳健发展
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="stat-card cyber-card text-center group"
            >
              <div
                className="w-14 h-14 rounded-2xl flex items-center justify-center mx-auto mb-4 transition-all group-hover:-translate-y-1"
                style={{ backgroundColor: `${stat.color}20` }}
              >
                <div style={{ color: stat.color }}>
                  <stat.icon />
                </div>
              </div>
              <div
                className="text-3xl md:text-4xl font-bold mb-2"
                style={{ color: stat.color }}
              >
                {stat.displayValue ? (
                  stat.displayValue
                ) : (
                  <Counter end={stat.value} suffix={stat.suffix} />
                )}
              </div>
              <div className="text-[#8080a0] text-sm">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 flex flex-wrap justify-center gap-8">
          <div className="flex items-center gap-2 text-[#8080a0]">
            <div className="w-2 h-2 rounded-full bg-[#00ff88]" />
            <span>系统运行正常</span>
          </div>
          <div className="flex items-center gap-2 text-[#8080a0]">
            <div className="w-2 h-2 rounded-full bg-[#00ff88]" />
            <span>风控系统在线</span>
          </div>
          <div className="flex items-center gap-2 text-[#8080a0]">
            <div className="w-2 h-2 rounded-full bg-[#00ff88]" />
            <span>资产保险覆盖</span>
          </div>
          <div className="flex items-center gap-2 text-[#8080a0]">
            <div className="w-2 h-2 rounded-full bg-[#00ff88]" />
            <span>24/7客服支持</span>
          </div>
        </div>
      </div>
    </section>
  )
}
